"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _digiwashCore = require("digiwash-core");

var _Box = _interopRequireDefault(require("../Box"));

var _Stack = _interopRequireDefault(require("../Stack"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _number = require("../helpers/number");

var _Divider = _interopRequireDefault(require("../Divider"));

var _ProductItemHelpers = require("./ProductItem-helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ProductItem(props) {
  let mainColor = props?.theme?.main || "primary";
  let cardBg = `${mainColor}.light940`;
  let {
    data
  } = props;

  if (!data) {
    return null;
  }

  let hasTotalPrice = typeof data.total_price === "number" || typeof data.total_price === "string";
  let hasPreviousPrice = typeof data.previous_price === "number" || typeof data.previous_price === "string";
  return /*#__PURE__*/_react.default.createElement(_Stack.default, null, /*#__PURE__*/_react.default.createElement(_reactNative.TouchableOpacity, {
    style: {
      flexGrow: 1,
      flexShrink: 1
    },
    onPress: () => {
      if (props.onClick) {
        props.onClick(data);
      }
    },
    onLongPress: props.onLongPress
  }, /*#__PURE__*/_react.default.createElement(_reactNative.TouchableOpacity, {
    onPress: () => {
      if (props.onClick) {
        props.onClick(data);
      }

      if (_reactNative.Platform.OS === "web" && props.link) {
        window.open(props.link, "_blank");
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    p: "m",
    br: "m",
    bg: cardBg
  }, /*#__PURE__*/_react.default.createElement(_Stack.default, {
    distribution: "space-between",
    alignment: "center"
  }, /*#__PURE__*/_react.default.createElement(_Box.default, {
    style: {
      flexShrink: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_Stack.default, {
    direction: "vertical",
    alignment: "end"
  }, hasPreviousPrice ? /*#__PURE__*/_react.default.createElement(_Box.default, {
    bg: "red.light",
    px: "l",
    br: "m"
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    fs: "s",
    color: "red.main"
  }, `${(0, _digiwashCore.formatNumber)(
  /* @ts-ignore farzad will fix*/
  (0, _ProductItemHelpers.percentCalc)(data.previous_price, data.total_price))}٪ تخفیف`)) : null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: "common.black",
    numberOfLines: 1,
    ellipsizeMode: "tail"
  }, data.title))), /*#__PURE__*/_react.default.createElement(_Stack.default, null, /*#__PURE__*/_react.default.createElement(_Stack.default, {
    distribution: "center",
    direction: "vertical"
  }, hasPreviousPrice ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
    fs: "s",
    color: "red.main",
    style: {
      textDecorationLine: "line-through",
      textDecorationStyle: "solid"
    }
  }, typeof data.previous_price === "number" ? `${(0, _number.formatPrice)(data.previous_price)} تومان` : null, typeof data.previous_price === "string" ? data.previous_price : null) : null, hasTotalPrice ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
    ff: "mainBold",
    color: `${mainColor}.dark`
  }, typeof data.total_price === "number" ? `${(0, _number.formatPrice)(data.total_price)} تومان` : null, typeof data.total_price === "string" ? data.total_price : null) : null), !!props.sub ? props.sub : null)), /*#__PURE__*/_react.default.createElement(_Box.default, null, data.description ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Divider.default, {
    size: "m"
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    fs: "s",
    color: "neutrals.700",
    alignment: "center"
  }, data.description)) : null)))), props.children);
}

var _default = ProductItem;
exports.default = _default;